export const removeZero = (obj) =>
    Object.keys(obj)
        .filter((key) => obj[key] !== 0)
        .reduce((newObj, key) => {
            newObj[key] = obj[key];
            return newObj;
        }, {});